module.exports = __webpack_public_path__ + "img/fashion_103.37f48a3d.jpg";